var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAuditsIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "a",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(1 3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.3,27.834H4.939V6.873H8.225a.438.438,0,1,0,0-.873H4.469A.455.455,0,0,0,4,6.437V28.271a.455.455,0,0,0,.469.437H17.3a.438.438,0,1,0,0-.873Z",
    transform: "translate(0 -2.122)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.469,6.939h3.286v8.482a.469.469,0,0,0,.939,0V6.469A.471.471,0,0,0,42.225,6H38.469a.469.469,0,0,0,0,.939Z",
    transform: "translate(-18.717 -2.122)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.469,6.694h8.449a.471.471,0,0,0,.469-.469V4.347a.471.471,0,0,0-.469-.469H22.994a2.348,2.348,0,0,0-4.6,0H16.469A.471.471,0,0,0,16,4.347V6.225A.471.471,0,0,0,16.469,6.694Zm.469-1.878h1.878a.471.471,0,0,0,.469-.469,1.408,1.408,0,0,1,2.816,0,.471.471,0,0,0,.469.469h1.878v.939H16.939Z",
    transform: "translate(-6.673)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.805,33.524a1.884,1.884,0,0,0-1.253-3.032.947.947,0,0,1-.826-.826,1.884,1.884,0,0,0-3.032-1.253.951.951,0,0,1-1.169,0,1.884,1.884,0,0,0-3.032,1.253.947.947,0,0,1-.826.826,1.884,1.884,0,0,0-1.253,3.032.951.951,0,0,1,0,1.169,1.884,1.884,0,0,0,1.253,3.032.947.947,0,0,1,.826.826,1.881,1.881,0,0,0,3.032,1.253.951.951,0,0,1,1.169,0,1.884,1.884,0,0,0,3.032-1.253.947.947,0,0,1,.826-.826,1.884,1.884,0,0,0,1.253-3.032.951.951,0,0,1,0-1.169Zm-.742,1.746A.95.95,0,0,1,44.43,36.8a1.889,1.889,0,0,0-1.643,1.643.938.938,0,0,1-.577.76.948.948,0,0,1-.948-.127,1.882,1.882,0,0,0-2.324,0,.95.95,0,0,1-1.526-.634A1.884,1.884,0,0,0,35.769,36.8a.95.95,0,0,1-.634-1.526,1.882,1.882,0,0,0,0-2.324.95.95,0,0,1,.634-1.526,1.889,1.889,0,0,0,1.643-1.643.938.938,0,0,1,.577-.76,1,1,0,0,1,.366-.075.963.963,0,0,1,.582.2,1.882,1.882,0,0,0,2.324,0,.95.95,0,0,1,1.526.634,1.884,1.884,0,0,0,1.643,1.643.95.95,0,0,1,.634,1.526A1.882,1.882,0,0,0,45.064,35.271Z",
    transform: "translate(-16.838 -15.501)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.834,36.135l-2.953,2.953-1.075-1.075a.468.468,0,0,0-.662.662l1.408,1.408a.461.461,0,0,0,.333.136.481.481,0,0,0,.333-.136L46.505,36.8a.468.468,0,0,0-.662-.662Z",
    transform: "translate(-20.552 -19.173)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.429,54.585a.468.468,0,0,0-.6.282l-.535,1.46-2.206-.8.643-1.554a.47.47,0,1,0-.868-.361l-.831,2.009a.506.506,0,0,0,0,.371.488.488,0,0,0,.268.253l3.108,1.127a.477.477,0,0,0,.16.028.468.468,0,0,0,.441-.31l.695-1.9a.468.468,0,0,0-.282-.6Z",
    transform: "translate(-17.064 -28.934)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.767,53.613a.47.47,0,0,0-.868.361l.643,1.554-2.206.8-.535-1.46a.469.469,0,0,0-.882.319l.695,1.9a.468.468,0,0,0,.441.31.477.477,0,0,0,.16-.028l3.107-1.127a.468.468,0,0,0,.268-.624l-.831-2.009Z",
    transform: "translate(-24.734 -28.934)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.816,36.469A.471.471,0,0,0,12.347,36H10.469a.471.471,0,0,0-.469.469v1.878a.471.471,0,0,0,.469.469h1.878a.471.471,0,0,0,.469-.469Zm-.939,1.408h-.939v-.939h.939Z",
    transform: "translate(-3.184 -19.111)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.347,46H10.469a.471.471,0,0,0-.469.469v1.878a.471.471,0,0,0,.469.469h1.878a.471.471,0,0,0,.469-.469V46.469A.471.471,0,0,0,12.347,46Zm-.469,1.878h-.939v-.939h.939Z",
    transform: "translate(-3.184 -24.732)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.832,17.107a.47.47,0,1,0-.723.6l.784.939a.471.471,0,0,0,.723,0l1.563-1.878a.47.47,0,1,0-.723-.6L11.25,17.614l-.422-.507Z",
    transform: "translate(-3.185 -7.869)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.113,26.107a.47.47,0,0,0-.662.061l-1.206,1.446-.422-.507a.47.47,0,0,0-.723.6l.784.939a.471.471,0,0,0,.723,0l1.563-1.878a.47.47,0,0,0-.061-.662Z",
    transform: "translate(-3.179 -13.49)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.8,16.469A.471.471,0,0,0,29.327,16H19.469a.469.469,0,0,0,0,.939h9.858A.471.471,0,0,0,29.8,16.469Z",
    transform: "translate(-8.375 -7.839)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.469,20.939h4.694a.469.469,0,0,0,0-.939H19.469a.469.469,0,0,0,0,.939Z",
    transform: "translate(-8.271 -10.079)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.567,26.469A.471.471,0,0,0,28.1,26H19.469a.469.469,0,0,0,0,.939H28.1A.471.471,0,0,0,28.567,26.469Z",
    transform: "translate(-8.345 -13.438)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.469,30.939h4.694a.469.469,0,0,0,0-.939H19.469a.469.469,0,0,0,0,.939Z",
    transform: "translate(-8.271 -15.678)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.469,36.939h5.173a.469.469,0,0,0,0-.939H19.469a.469.469,0,0,0,0,.939Z",
    transform: "translate(-8.279 -19.038)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.469,40.939h4.694a.469.469,0,0,0,0-.939H19.469a.469.469,0,0,0,0,.939Z",
    transform: "translate(-8.271 -21.277)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.29,46.469A.471.471,0,0,0,24.821,46H19.469a.469.469,0,0,0,0,.939h5.351A.471.471,0,0,0,25.29,46.469Z",
    transform: "translate(-8.281 -24.637)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.469,50a.469.469,0,0,0,0,.939h4.694a.469.469,0,1,0,0-.939Z",
    transform: "translate(-8.271 -26.877)",
    fill: "#fff",
    stroke: "#fff",
    strokeWidth: 0.2
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAuditsIcon);
export default __webpack_public_path__ + "static/media/audits-icon.2c4acfe447bf53de0690f5408fc4d04a.svg";
export { ForwardRef as ReactComponent };